<h1 mat-dialog-title>
  <span *ngIf="data.action === 'new'">{{ 'common.words.new' | translate }} - </span>
  {{ data.modalTitle }}
</h1>
<ng-container class="digital-document-wrapper">
  <div class="row p-5">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center">
          <mat-spinner-button (btnClick)="onPrint('module')" [options]="printModuleBtnOptions" class="btn-elevate">
          </mat-spinner-button>
          <mat-spinner-button (btnClick)="onPrint('qr')" [options]="printQrBtnOptions" class="btn-elevate ml-2">
          </mat-spinner-button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="text-left w-100">
        <a mat-button (click)="onClose({ save: 'success' })" mat-raised-button mat-default
          class="ml-3">{{ 'common.cta.close' | translate }}</a>
      </div>
    </div>
  </div>
</ng-container>